import { lastValueFrom } from 'rxjs';
import { CpApi } from '../cp-api';
import { CpUserInfoDetails, createCpUserInfoDetailsFromHttpJson } from '../models/cp-user-info-details';

export async function cpGetUserInfoDetails(cpApi: CpApi): Promise<CpUserInfoDetails> {
  return lastValueFrom(
    cpApi.http.getMapped(
      `${cpApi.userApiUrl}details/`,
      [createCpUserInfoDetailsFromHttpJson],
      cpApi.apiConfig.getUserAuthOptions()
    )
  );
}
